import { Action } from '@ngrx/store';

import { HideLoader } from '../../shared/decorators/hide-loader';
import { ShowLoader } from '../../shared/decorators/show-loader';
import { User } from '../entities/user/user.model';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  Logout = '[Auth] Logout',
  LogoutLocal = '[Auth] LogoutLocal',
  // Refresh = '[Auth] Refresh',
  // RefreshSuccess = '[Auth] Refresh success',
  // RefreshFail = '[Auth] Refresh fail',
  GetLoggedUser = '[Auth] Get Logged user',
  GetLoggedUserSuccess = '[Auth] Get logged user success',
  GetLoggedUserFail = '[Auth] Get logged user fail',
  // Signup = '[Auth] Signup',
  // SignupSuccess = '[Auth] Signup success',
  // SignupFail = '[Auth] Signup fail',
  // ResetPassword = '[Auth] ResetPassword',
  // ResetPasswordSuccess = '[Auth] ResetPassword success',
  // ResetPasswordFail = '[Auth] ResetPassword fail',
  ForgotPassword = '[Auth] ForgotPassword',
  // ForgotPasswordSuccess = '[Auth] ForgotPassword success',
  // ForgotPasswordFail = '[Auth] ForgotPassword fail',
  ChangeLanguage = '[Auth] Change language',
  CheckAuth = '[Auth] Check auth',
  CheckAuthSuccess = '[Auth] Check auth success',
  CheckAuthFail = '[Auth] Check auth fail',
  SessionExpired = '[Auth] Session expired',
  ShowInformationAgreementPopup = '[Auth] Show Information Agreement popup',
  HideInformationAgreementPopup = '[Auth] Hide Information Agreement popup',
  AcceptInformationAgreement = '[Auth] Accept Information Agreement',
  AcceptInformationAgreementSuccess = '[Auth] Accept Information Agreement success',
  AcceptInformationAgreementFail = '[Auth] Accept Information Agreement fail',
}

export interface FailActionMessage extends Action {
  payload: string;
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;
  constructor() { }
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
}

export class LogoutLocal implements Action {
  readonly type = AuthActionTypes.LogoutLocal;
}

// export class Refresh implements Action {
//   readonly type = AuthActionTypes.Refresh;
//   constructor() { }
// }

// export class RefreshSuccess implements Action {
//   readonly type = AuthActionTypes.RefreshSuccess;
//   constructor() { }
// }

// export class RefreshFail implements FailActionMessage {
//   readonly type = AuthActionTypes.RefreshFail;
//   constructor(public payload: string) { }
// }

@ShowLoader()
export class GetLoggedUser implements Action {
  readonly type = AuthActionTypes.GetLoggedUser;
  constructor() { }
}
@HideLoader(AuthActionTypes.GetLoggedUser)
export class GetLoggedUserSuccess implements Action {
  readonly type = AuthActionTypes.GetLoggedUserSuccess;
  constructor(public loggedUser: User) { }
}
@HideLoader(AuthActionTypes.GetLoggedUser)
export class GetLoggedUserFail implements Action {
  readonly type = AuthActionTypes.GetLoggedUserFail;
  constructor(public payload: string) { }
}

export class ForgotPassword implements Action {
  readonly type = AuthActionTypes.ForgotPassword;
}

export class CheckAuth implements Action {
  readonly type = AuthActionTypes.CheckAuth;
  constructor() { }
}

export class CheckAuthSuccess implements Action {
  readonly type = AuthActionTypes.CheckAuthSuccess;
  constructor(public loggedIn: boolean) { }
}
export class CheckAuthFail implements Action {
  readonly type = AuthActionTypes.CheckAuthFail;
  constructor(public payload: string) { }
}

export class SessionExpired implements Action {
  readonly type = AuthActionTypes.SessionExpired;
}

export class ChangeLanguage implements Action {
  readonly type = AuthActionTypes.ChangeLanguage;
  constructor(public languageCode: string) { }
}


export class ShowInformationAgreementPopup implements Action {
readonly type = AuthActionTypes.ShowInformationAgreementPopup;
}

export class HideInformationAgreementPopup implements Action {
readonly type = AuthActionTypes.HideInformationAgreementPopup;
}

export class AcceptInformationAgreement implements Action {
  readonly type = AuthActionTypes.AcceptInformationAgreement;
  }

  export class AcceptInformationAgreementSuccess implements Action {
    readonly type = AuthActionTypes.AcceptInformationAgreementSuccess;
    constructor(public informationAgreement: boolean) { }
  }
  export class AcceptInformationAgreementFail implements Action {
    readonly type = AuthActionTypes.AcceptInformationAgreementFail;
    constructor(public payload: string) { }
  }

export type AuthActions =
  Login |
  Logout | LogoutLocal |
  // Refresh | RefreshSuccess | RefreshFail |
  CheckAuth | CheckAuthSuccess | CheckAuthFail |
  GetLoggedUser | GetLoggedUserSuccess | GetLoggedUserFail |
  ForgotPassword |
  ChangeLanguage | SessionExpired
  | ShowInformationAgreementPopup | HideInformationAgreementPopup
  | AcceptInformationAgreement | AcceptInformationAgreementSuccess | AcceptInformationAgreementFail;
